/** APIのベースURL */

import { Auth } from 'aws-amplify';

//TODO: 環境ごとの接続先を切り替える
const HOST = process.env.REACT_APP_API_HOST;

export async function GET(path: string, cancellation?: AbortSignal) {
  return await Call(path, { method: 'GET', signal: cancellation });
}

export async function POST(
  path: string,
  params?: Record<string, unknown> | FormData,
  withFile: boolean = false,
  cancellation?: AbortSignal
) {
  if (!withFile) {
    const options = {
      method: 'POST',
      body: JSON.stringify(params),
      headers: { 'Content-Type': 'application/json' },
      signal: cancellation,
    };
    return await Call(path, options);
  } else {
    const body = params instanceof FormData ? params : JSON.stringify(params);
    return await Upload(path, body, cancellation);
  }
}

export async function PUT(path: string, params?: Record<string, unknown>) {
  return await Call(path, {
    method: 'PUT',
    body: JSON.stringify(params),
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function DELETE(path: string, params?: Record<string, unknown>) {
  return await Call(path, {
    method: 'DELETE',
    body: JSON.stringify(params),
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function Call(path: string, options?: RequestInit) {
  const user = await Auth.currentAuthenticatedUser().catch(() => null);
  const opts = {
    ...options,
    headers: {
      ...(user != null
        ? { Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}` }
        : {}),
      ...options?.headers,
    },
  };
  const response = await fetch(`${HOST}/${path}`, opts);
  return await TryParseResponse(response);
}

async function Upload(path: string, body: BodyInit | null, cancellation?: AbortSignal) {
  const options = {
    method: 'POST',
    body: body,
    signal: cancellation,
  };
  const response = await fetch(`${HOST}/${path}`, options);
  return await TryParseResponse(response);
}

export class FetchError extends Error {
  private _response: Response;
  constructor(res: Response, message?: string) {
    super(message);
    this._response = res;
    this.name = 'FetchError';
  }
  // 同じレスポンスのインスタンスに対して複数回json()を呼び出すことができるようにするため、getterを使い複製したレスポンスを返す
  get response() {
    return this._response.clone();
  }
}

async function TryParseResponse(response: Response) {
  if (!response.ok) {
    //TODO:例外をもう少し細かくする？
    throw new FetchError(response, `HTTP ERROR: ${response.status}`);
  }

  return await response.json();
}
